<div class="detail-page b-padd">
  <section class="video-detail">
    <div class="sub-poster">
      <img [src-fallback]="app_constant.landscapeDefault" [src]="thumbnails" />
    </div>
    <div
      class="subscription-plan"
      [ngClass]="{
        'content-sub':
          videoDetail.is_subscription !== 'yes' &&
          (videoDetail.one_time_purchase || videoDetail.rental_price)
      }"
    >
      <div class="container">
        <div class="sub-content">
          <h3>{{ videoDetail?.name }}</h3>
          <!-- <ul>
                        <li>
                        <span class="icon-sale"></span> Top-related Originals like Asur and illegal
                        </li>
                        <li>
                        <span class="icon-pending-videos"></span> 24 Hours Defore TV
                        </li>
                        <li>
                        <span class="icon-search"></span> Latest International Show
                        </li>
                        <li>
                        <span class="icon-access-control"></span> 35+ Live TV channels
                        </li>
                        <li>
                        <span class="icon-video-camera"></span> 1500+ Movies in 9 Languages
                        </li>
                        <li>
                        <span class="icon-show-pass"></span> MTV Roadies 24 Hours Before TV
                        </li>
                        <li>
                        <span class="icon-dashboard"></span> Add-free Experience
                        </li>
                    </ul> -->
        </div>
        <div
          *ngIf="videoDetail.is_subscription === 'yes'"
          class="d-flex sub-box-data mb-3"
        >
          <div
            class="sub-price-box"
            *ngFor="let plan of subscription; let i = index"
          >
            <input
              [value]="i + 1"
              [(ngModel)]="subscriptionPlan"
              name="subscription-type"
              checked
              class="form-check-input"
              type="radio"
              id="Standard-{{ i }}"
            />
            <label for="Standard-{{ i }}">
              <h6>{{ plan.type | translate | uppercase }}</h6>
              <!-- <h3 class="plan-exp">$49.99</h3>
                            <h4>Pre Launch Offer</h4> -->
              <h3 class="text-center">{{ plan.price }}</h3>
              <h4>{{ plan.duration | translate }}</h4>
              <h5>{{ plan.heading | translate }}</h5>
              <ul>
                <li
                  *ngFor="
                    let feature of plan.description.feature
                      | limitTo: planArrayLimit:i:changeIndex;
                    let i = index
                  "
                >
                  -
                  {{ feature | translate }}
                </li>
              </ul>
              <div class="mt-3" *ngIf="plan.description.feature.length > 4">
                <a
                  href="javascript:void(0)"
                  class="text-primary"
                  *ngIf="
                    (
                      plan.description.feature
                      | limitTo: planArrayLimit:i:changeIndex
                    ).length < 5
                  "
                  (click)="viewMore(i)"
                  ><u>{{ "SUBSCRIPTION_INFO.VIEW_MORE" | translate }}</u></a
                >
                <a
                  href="javascript:void(0)"
                  class="text-primary"
                  *ngIf="
                    (
                      plan.description.feature
                      | limitTo: planArrayLimit:i:changeIndex
                    ).length > 4
                  "
                  (click)="planArrayLimit = 4"
                  ><u>{{ "SUBSCRIPTION_INFO.VIEW_LESS" | translate }}</u></a
                >
              </div>
            </label>
            <span class="radio"></span>
          </div>
        </div>
        <div class="d-flex subscription-btn">
          <button
            (click)="goSubscription()"
            *ngIf="videoDetail.is_subscription === 'yes'"
            class="btn btn-theme"
          >
            {{ "CONTENT_SUBSCRIPTION_INFO.SUBSCRIBE_BUTTON" | translate }}
          </button>
          <button
            routerLink="/payment/purchase/{{ videoDetail?.type }}/{{
              videoDetail?.public_id
            }}"
            *ngIf="videoDetail.one_time_purchase"
            class="btn btn-theme ml-3"
          >
            {{ "CONTENT_SUBSCRIPTION_INFO.BUY_BUTTON" | translate }} ${{
              videoDetail.one_time_purchase
            }}
          </button>
          <button
            routerLink="/payment/rental/{{ videoDetail?.type }}/{{
              videoDetail?.public_id
            }}"
            *ngIf="videoDetail.rental_price"
            class="btn btn-theme ml-3"
          >
            {{ "CONTENT_SUBSCRIPTION_INFO.RENT_BUTTON" | translate }} ${{
              videoDetail.rental_price
            }}
            for {{ videoDetail.rental_price_days | daysConvert }}
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
